// src/pages/Privacy.js
import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ReactMarkdown from "react-markdown";
import { Helmet } from 'react-helmet-async'; // Correct import
import Faq from "../components/Faq";
import InBlog from "../components/InBlog";
import ChatButton from "../components/ChatButton";

function Privacy() {
  // Privacy policy content in markdown
  const markdownContent = `
# Independent and Focused
### Built for small businesses.

Seotic is an SEO tool crafted by a small team who’s spent years in the trenches of [Digital Marketing](https://www.pixelliongroup.com) and web development. We’ve worked with startups, agencies and enterprise clients. We’ve seen what works and more often, what gets in the way.

We built Seotic because we believe SEO shouldn’t feel like magic or a mess.

You shouldn’t have to juggle five different tools to understand how your website is performing. You shouldn’t need an expert just to know what to fix. And you definitely shouldn’t have to pay a fortune for it.

So we created Seotic an all in one SEO toolkit that’s clean, clear and actually useful. It gives you the essentials:

- A website audit that highlights real issues
- A backlinks tool that makes sense
- A keyword tracker that shows what matters
- Competitor insights that are easy to act on

We didn’t set out to build the most feature packed tool. We set out to build the most usable one. Something that helps you move faster, make better decisions and grow without the guesswork.

No bloated dashboards. No fluff. Just solid and straightforward SEO.

We’re building Seotic for ourselves and for everyone else who wants their site to rank without getting lost in complexity.

We hope you’ll find it as helpful as we do.
  `;

  return (
    <>
     {/* Helmet component to wrap all meta tags and title */}
      <Helmet>
        <title>Seotic About - Powerful SEO Tools for Small Businesses</title>
        <meta
          name="description"
          content="Seotic provides easy to use SEO tools for small businesses to enhance online visibility, drive traffic, and grow your brand. Get started with Seotic today!"
        />
        <meta name="keywords" content="SEO, SEO tools, small business, digital marketing, online visibility, Seotic" />
        <link rel="icon" href="https://www.seotic.co/favicon.ico" />

        {/* Open Graph Meta Tags */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.seotic.co" />
        <meta property="og:title" content="Seotic - SEO Tools for Small Businesses" />
        <meta
          property="og:description"
          content="Optimize your website's SEO with Seotic's powerful, user friendly tools designed for small businesses. Start improving your search rankings today!"
        />
        <meta property="og:image" content="https://www.seotic.co/og-image.jpg" />

        {/* Twitter Card Meta Tags */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://www.seotic.co" />
        <meta property="twitter:title" content="Seotic - SEO Tools for Small Businesses" />
        <meta
          property="twitter:description"
          content="Optimize your website's SEO with Seotic's powerful, user friendly tools designed for small businesses. Start improving your search rankings today!"
        />
        <meta property="twitter:image" content="https://www.seotic.co/og-image.jpg" />
      </Helmet>

      <Navbar />
      <div className="max-w-3xl  mx-auto py-20 px-4 lg:px-0 md:shadow-lg rounded text-md my-10 md:border md:-rotate-2 hover:rotate-0">
        <h1 className="md:text-4xl text-6xl px-5 md:px-20 mb-5 text-gray-900 max-w-3xl mx-auto">Independent and Focused</h1>
        <p className="mb-5 bg-gradient-to-b text-lg md:text-md from-white via-neutral-100/50 to-neutral-200/20 px-5 md:px-20">At Seotic, we’re not a giant corporation with endless layers of management. We’re a small, passionate team of marketers, developers and creators who’ve spent years living and breathing the digital world. We’ve been inside agencies, worked with startups and partnered with enterprises. Along the way, we’ve celebrated wins, learned from mistakes and discovered what really moves the needle in SEO. That’s why we built Seotic. Not because the world needs “just another SEO tool,” but because we wanted something that actually makes sense for real people. We were tired of juggling five different dashboards, endless spreadsheets and complicated software that only created more confusion.</p>

<p className="mb-5 text-lg md:text-md  bg-gradient-to-b from-white via-neutral-100/50 to-neutral-200/20 px-5 md:px-20">With Seotic, we set out to strip away the noise and focus on what matters most. We built a tool that feels like having a teammate by your side, one that highlights real issues on your website, helps you understand your backlinks, tracks the keywords that actually matter and shows you what your competitors are up to without overwhelming you. We didn’t chase “more features” just for the sake of it. Instead, we focused on usability. Seotic is built to help you move faster, make smarter decisions and grow your website with clarity and confidence.</p>

<p className="px-5 text-lg md:text-md md:px-20">Our philosophy is simple. No bloated dashboards, no hidden gimmicks and no unnecessary complexity. Just solid, straightforward SEO that helps you take action. At the end of the day, we’re building Seotic not just for clients but for ourselves too. It’s the tool we wish we had years ago. And now, we get to share it with every business owner, marketer and dreamer who wants to rank higher without getting lost in the weeds. We’re proud of what we’ve built, and even prouder of the community we’re building it with. And we can’t wait for you to be part of it. <p className="mt-5">Team Seotic</p></p>
      
         {/* <div className="prose prose-lg mx-auto max-w-3xl">
          <ReactMarkdown>{markdownContent}</ReactMarkdown>
        </div> */}
      </div>
      
        <Faq />
        <div className="container mx-auto my-10">
          <ChatButton />
        </div>

      <Footer />
    </>
  );
}

export default Privacy;
